import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Next.js Image optimization strips animation from GIFs and emits a runtime
// warning when fed an animated source. Detect those by URL so callers can pass
// `unoptimized` and serve the original file unchanged.
export function isAnimatedImageSrc(src: unknown): boolean {
  if (typeof src !== 'string') return false;
  const path = src.split('?')[0].toLowerCase();
  return path.endsWith('.gif');
}
